<template>
  <span class="n-icon">
    <svg viewBox="0 0 24 24" :fill="fill">
      <path
        fill="currentColor"
        d="M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z"
      />
    </svg>
  </span>
</template>

<script lang="ts" setup>
defineProps({
  fill: {
    type: String,
    default: 'currentColor',
  },
});

defineOptions({
  name: 'n-chevron-right-icon',
});
</script>
